import { writable } from 'svelte/store';

export const currentReplyCommentId = writable(null);